goog.provide("shadow.js.shim.module$date_fns$locale$nl$default");
shadow.js.shim.module$date_fns$locale$nl$default = esm_import$date_fns$locale$nl.default;
